import React from 'react';
import { Dialog, DialogTitle } from '.';
import { DialogContent } from '../dialogs';
import { Alert, Box, Button, Typography } from '@mui/material';
import { IZone } from '../../models';
import CloseIcon from '@mui/icons-material/Close';
import { ZoneSubscribeForm } from 'forms/zones/zone-subscribe/zone-subscribe.form';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface SubscribeDialogProps {
  visible: boolean;
  onClose: () => void;
  zone: IZone;
}
export const SubscribeDialog = (props: SubscribeDialogProps) => {
  const { zone, visible = false, onClose = () => {} } = props;
  const form = React.useRef<any>();
  const [isSuccess, setIsSuccess] = React.useState(false);

  React.useEffect(() => {
    if (form.current) {
      setIsSuccess(form.current.isSuccess);
    }
  }, [form.current]);

  const handleLoginSuccess = () => {
    // close modal
    onClose();
  };

  const handleClickSubmit = () => {
    form.current.onSubmit();
  };

  return (
    <Dialog open={visible}>
      <DialogTitle sx={{ textAlign: 'center' }}>
        <Typography color="primary" style={{ fontWeight: 'bold', fontSize: 18 }}>
          Get real-time updates when this space is cleaned
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Enter your phone number below and you&apos;ll receive a text message whenever this space is cleaned.
        </Typography>

        {isSuccess ? (
          <Alert color="success" icon={<CheckCircleIcon />}>
            You have successfully subscribed to service alerts.
          </Alert>
        ) : (
          <>
            <ZoneSubscribeForm ref={form} zone={zone} next={handleLoginSuccess} />

            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography variant="caption">Message and data rates may apply.</Typography>
              <Typography variant="caption">Reply STOP to cancel updates.</Typography>
            </Box>

            <Button variant="contained" onClick={() => handleClickSubmit()} sx={{ mt: 2 }}>
              Subscribe
            </Button>
          </>
        )}

        <Button startIcon={<CloseIcon />} sx={{ mt: 2 }} onClick={onClose} fullWidth>
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};
